export default __webpack_public_path__ + "static/media/E-Commerce 2.f81eb441.svg";